import { CSSProperties } from 'react';
import cx from 'classnames';

import styles from './skeleton.module.scss';

type SkeletonProps = {
  width?: number | string;
  height?: number | string;
  radius?: number | string;
  className?: string;
  circle?: boolean;
};

export default function Skeleton({ width, height, radius, className, circle }: SkeletonProps) {
  const style: CSSProperties = {
    width,
    height,
    borderRadius: circle ? '50%' : radius
  };

  return <div className={cx(styles.skeleton, className)} style={style} aria-hidden="true" />;
}
